import { ModelDef } from '../../CORE/src/common/$models/ModelDef'

/**
 * 見積:家具移動オプション回答マスタ
 * - 選択肢と上乗せ金額
 */
export const yhc_kazai_kaguido_destination_options_and_prices: ModelDef = {
  tableName: 'yhc_kazai_kaguido_destination_options_and_prices',
  tableLabel: '見積:家具移動オプション回答マスタ',
  tableComment: '見積:家具移動オプション選択肢と上乗せ金額',
  primaryKeyColType: 'NUMBER',
  replicable: true,
  columns: {
    question: {
      type: 'RELATIONSHIP_MANY_TO_ONE',
      label: '移動元・先質問',
      replicable: true,
      validate: { notEmpty: true },
      relationshipManyToOne: {
        collectionName: 'yhc_kazai_kaguido_destination_questions',
        labelFormatter: (row) => `${row.adminName}-${row.questionText}`,
      },
    },
    optionText: {
      type: 'STRING',
      label: '選択肢',
      replicable: true,
      validate: { notEmpty: true },
    },
    additionalPrice: {
      type: 'NUMBER',
      label: '追加料金',
      replicable: true,
      validate: { notEmpty: true },
    },
    enabledFrom: {
      type: 'DATETIME',
      label: '有効期間 開始',
      replicable: true,
      validate: { notEmpty: true },
    },
    disabledAt: {
      type: 'DATETIME',
      label: '有効期間 終了',
      replicable: true,
      validate: { notEmpty: true },
    },
  },
}
